module.exports = __webpack_public_path__ + "static/img/column_recommendation1_2.ed589ab7.png";